import React, { Component } from "react";
import { reactLocalStorage } from 'reactjs-localstorage';
import Apihelpers from "./helper/ApiHelper";
import { LOGIN_API, CLIENT_LIST_ROUTE, LOGIN_TYPE_ADMIN, LOGIN_TYPE_USER, CLIENT_EDIT_VIEW_ROUTE, NEET_HELP_EMAIL, SERVICE13_TEXT, SERVICE14_TEXT, SERVICE20_TEXT, SERVICE18_TEXT, SERVICE28_TEXT, SERVICE36_TEXT,SERVICE29_TEXT, SERVICE30_TEXT, SERVICE32_TEXT,
   SERVICE21_TEXT, SERVICE31_TEXT, SERVICE10_TEXT,SERVICE37_TEXT,SERVICE38_TEXT,SERVICE40_TEXT, SERVICE41_TEXT, SERVICE42_TEXT } from "./helper/Constants";
import { NavLink } from "react-router-dom";


class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      isAuth: null,
      isSubmitted: false,
      captcha:'',
      captchaInput:'',
      generatedCaptcha:'',
      captchaError:''
    };
  }
  componentWillMount() {
    var url = window.location.href;
    var arr = url.split("/");
    const token = reactLocalStorage.get("authToken");
    const tokenExpireDate = reactLocalStorage.get("expires_at");
    if (token !== "" && token !== undefined) {

      const now = new Date().valueOf();
      if (now <= tokenExpireDate) {
        url = arr[0] + "//" + arr[2] + "/" + arr[3] + CLIENT_LIST_ROUTE;
        window.location.href = url;
      } else {
        reactLocalStorage.clear();
      }
    } else {
      reactLocalStorage.clear();
    }
  }
  componentDidMount(){
    this.generateCaptcha();
  }
  generateCaptcha = () => {
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let captcha = '';
    for (let i = 0; i < 6; i++) {
      captcha += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    this.setState({generatedCaptcha:captcha});
  }

  onChangeValue = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  loginSubmit = (e) => {
    e.preventDefault();
    if (this.state.captchaInput !== this.state.generatedCaptcha) {
      let errMsg = 'CAPTCHA is incorrect. Please try again.'
      if(this.state.captchaInput === '') {
        errMsg = 'CAPTCHA is required'
      }
      this.setState({
        captchaError: errMsg,
      });
      this.generateCaptcha();
      return;
    }
    this.setState({
      isSubmitted: true
    });

    const Authpostdata = {
      useremail: this.state.email,
      userpassword: this.state.password,
    };

    if (this.state.password !== "" && this.state.email !== "") {
      document.querySelector(".loader").style.display = "block";
      Apihelpers.postdataresponseWOToken(LOGIN_API, Authpostdata).then(res => {
        if (res.data.status === true) {
          this.setState({
            isAuth: true,
          });
          reactLocalStorage.set('authToken', res.data.token);
          reactLocalStorage.set("expires_at", res.data.expire_datetime_timestamp); //2021-03-22 06:22:55
          reactLocalStorage.set("login_type", res.data.data[0].user_type);
          reactLocalStorage.set("user_name", res.data.data[0].name);
          if (res.data.data[0].user_type === LOGIN_TYPE_ADMIN) {
            let internalToken = res.data.data[1].token;
            reactLocalStorage.set("internalToken", internalToken);
          } else if (res.data.data[0].user_type === LOGIN_TYPE_USER) {
            reactLocalStorage.set("login_user_id", res.data.data[1]._id);
            let plans = JSON.parse(res.data.data[1].active_plan).service;
            console.log('plans',plans);
            plans.forEach((obj)=>{
              if (obj.plantype === SERVICE13_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_primePDF_service", obj.plantype);
              } else if (obj.plantype === SERVICE14_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api-history_service", obj.plantype);
              } else if (obj.plantype === SERVICE20_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api_variant_mapping_service", obj.plantype);
              } else if (obj.plantype === SERVICE18_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api_challanpdf_service", obj.plantype);
              } else if (obj.plantype === SERVICE28_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api_panFetchpdf_service", obj.plantype);
              } else if (obj.plantype === SERVICE36_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api_aadhaarFetchpdf_service", obj.plantype);
              } else if (obj.plantype === SERVICE29_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api_panExtensivepdf_service", obj.plantype);
              } else if (obj.plantype === SERVICE30_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api_aadhaarExtractionpdf_service", obj.plantype);
              } else if (obj.plantype === SERVICE31_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api_basicForgerypdf_service", obj.plantype);
              } else if (obj.plantype === SERVICE32_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_api_advanceForgerypdf_service", obj.plantype);
              } else if (obj.plantype === SERVICE21_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_rcPrimeReversePdf_service", obj.plantype);
              } else if (obj.plantype === SERVICE10_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_rcExcel_service", obj.plantype);
              } else if (obj.plantype === SERVICE37_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_challanExcel_service", obj.plantype);
              } else if (obj.plantype === SERVICE38_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_mobile_rc_excel_service", obj.plantype);
              } else if (obj.plantype === SERVICE40_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_raw_report_service", obj.plantype);
              } else if (obj.plantype === SERVICE41_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_buheadbilling_service", obj.plantype);
              } else if (obj.plantype === SERVICE42_TEXT && obj.isActive === 1) {
                reactLocalStorage.set("is_have_dashboard_service", obj.plantype);
              } 

            })

            let internalToken = res.data.data[1].token;
            reactLocalStorage.set("internalToken", internalToken);
            //console.log('internalToken',internalToken);
          }

          // console.log(res.data.data[0].user_type);
          var url = window.location.href;
          var arr = url.split("/");
          if (res.data.data[0].user_type !== LOGIN_TYPE_ADMIN) {
            url = arr[0] + "//" + arr[2] + "/" + arr[3] + CLIENT_EDIT_VIEW_ROUTE + "/" + res.data.data[1]._id;
          } else {
            url = arr[0] + "//" + arr[2] + "/" + arr[3] + CLIENT_LIST_ROUTE;
          }

          window.location.href = url;
        } else {
          this.setState({
            isAuth: false,
            captchaError:''
          });
          document.querySelector(".loader").style.display = "none";
        }
      });
    }
  }



  render() {
    return (<React.Fragment>
      <div className="wrapper">
        <div className="container">
          <div className="flexWrapper">
            <div className="loginPopUp">
              <div className="popUpLogo">
                <img src="/assets/images/logo.png" alt="" />
              </div>
              <form className="form" onSubmit={this.loginSubmit}>
                <div className="form-group">
                  <label className="control-title">E-mail <span className="ex">*</span></label>
                  <input className="form-control" onChange={this.onChangeValue} type="text" placeholder="Enter Email ID" name="email" required />
                  {(this.state.isSubmitted == true) && (this.state.email == "") ? (<span className="error">E-Mail is required</span>) : <span />}
                </div>
                <div className="form-group">
                  <label className="control-title">Password <span className="ex">*</span></label>
                  <input className="form-control" onChange={this.onChangeValue} type="password" placeholder="Enter Password" name="password" required />
                  {(this.state.isSubmitted == true) && (this.state.password == "") ? (<span className="error">Password is required</span>) : <span />}
                </div>
                <div className="form-group">
                  <label className="control-title">Captcha <span className="ex">*</span></label>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="captcha">{this.state.generatedCaptcha}</div>
                    </div>
                    <div className="col-md-8">
                      <input className="form-control" type="text" placeholder="Enter the CAPTCHA" value={this.state.captchaInput} onChange={(e) => 
                        this.setState({captchaInput:e.target.value})
                      } />
                    </div>
                  </div>
                  <div className="error">{this.state.captchaError}</div>
                </div>
                {this.state.isAuth == false ? <div style={{ color: "maroon" }}>Invalid Username and password</div> : <div />}
                <div className="submitRow">
                  <button className="blueBtn" type="submit">Submit</button>
                  {/* <a className="blueBtn" href="client-list-blank.html">Submit</a> */}

                  <NavLink
                    title="Edit"
                    className="forGot"
                    to={"/admin/forgot-password"}
                    exact
                    activeClassName="active"
                  >
                    Forgot Password?
                  </NavLink>
                </div>
              </form>
              <div className="bottomBg">
                Need help?  <a href={"mailto:" + NEET_HELP_EMAIL}>{NEET_HELP_EMAIL}</a>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="loader">
        <div className="bg"></div>
        <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
      </div>
    </React.Fragment>);
  }
}

export default Login;
